import type { Speak2MeStreamEvent } from '@vivport/backend/types';

export type Speak2MeStreamReadEvent =
  | Speak2MeStreamEvent
  | { type: 'error'; message: string };

export async function* readSpeak2MeStream(
  response: Response,
  signal: AbortSignal,
): AsyncIterable<Speak2MeStreamReadEvent> {
  if (!response.body) {
    throw new Error('Stream response has no body');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  const onAbort = (): void => {
    void reader.cancel();
  };
  signal.addEventListener('abort', onAbort);

  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let nl = buffer.indexOf('\n');
      while (nl !== -1) {
        const line = buffer.slice(0, nl);
        buffer = buffer.slice(nl + 1);
        if (line.length > 0) {
          yield JSON.parse(line) as Speak2MeStreamReadEvent;
        }
        nl = buffer.indexOf('\n');
      }
    }
    const tail = buffer.trim();
    if (tail.length > 0) {
      yield JSON.parse(tail) as Speak2MeStreamReadEvent;
    }
  } finally {
    signal.removeEventListener('abort', onAbort);
  }
}
